import { useMutation } from "react-query";
import { ggpsNew } from "src/welcome/data-access/gateway";

export const useGgpsNew = () => {
  return useMutation({
    mutationKey: ["ggpsNew"],
    mutationFn: ggpsNew,
    onSuccess: (data) => {
      window.location.href = data?.data?.url;
    },
  });
};
